import React, { useState,useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Logo from "../img/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

function PrivacyPolicy() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
    }, []);

  const handleLogout = () => {
    logout();
  };

   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy - Revexia</title>
        <meta
          name="description"
          content="Revexia Privacy Policy - Learn how we collect, use, and protect your personal data in accordance with GDPR and applicable data protection laws."
        />
      </Helmet>

      <div className="homepage">
        {/* Navigation - Same as HomePage */}
         <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  <Link to="/" className="nav-link-pill">
                    Home
                  </Link>
                </li>
                <li className="nav-item-pill">
                   <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                     <Link to="/facebook-terms" className="nav-dropdown-item">
                                          Facebook Terms
                                        </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dashboard" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/join-waitlist" className="btn-nav-gradient">
                                     Get Started
                                   </Link>
                                     <Link to="/auth" className="btn-nav-gradientlogin">
                                     Login
                                   </Link>
                </>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* Privacy Policy Content */}
        <div className="privacy-content-wrapper">
          {/* Header Section */}
          <div className="privacy-header-section">
            <div className="privacy-container">
              <h1 className="privacy-main-title">Privacy Policy</h1>
              <p className="privacy-last-updated">Last updated: 28.01.2026</p>
              <p className="privacy-intro-text">
                Revexia respects your privacy and is committed to protecting personal data.
                This Privacy Policy explains how we collect, use, store, and protect information
                when you use the Revexia platform and website.
              </p>
              <p className="privacy-intro-text">
                Revexia is a global SaaS platform and processes data in accordance with applicable
                data protection laws, including the EU General Data Protection Regulation (GDPR).
              </p>
            </div>
          </div>

          {/* Content Section */}
          <div className="privacy-content-section">
            <div className="privacy-container">
              {/* Section 1 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">1. Information We Collect</h2>
                <p className="privacy-paragraph">
                  We collect information in the following categories:
                </p>

                <div className="privacy-subsection">
                  <h3 className="privacy-subsection-title">a) Account Information</h3>
                  <p className="privacy-paragraph">When you create an account, we may collect:</p>
                  <ul className="privacy-list">
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Company or brand name</li>
                    <li>Login credentials</li>
                  </ul>
                </div>

                <div className="privacy-subsection">
                  <h3 className="privacy-subsection-title">b) Customer Interaction Data (via integrations)</h3>
                  <p className="privacy-paragraph">When authorized by you, Revexia may process:</p>
                  <ul className="privacy-list">
                    <li>Social media conversation metadata (e.g. timestamps, message content, interaction type)</li>
                    <li>Signals from connected DM tools (such as conversation events and tags)</li>
                    <li>Platform identifiers required to operate integrations</li>
                  </ul>
                  <p className="privacy-paragraph privacy-highlight">
                    Revexia only processes data that you explicitly authorize through platform integrations.
                  </p>
                </div>

                <div className="privacy-subsection">
                  <h3 className="privacy-subsection-title">c) Website & Usage Data</h3>
                  <p className="privacy-paragraph">We may collect usage and activity data such as:</p>
                  <ul className="privacy-list">
                    <li>Page views and interactions on connected websites</li>
                    <li>Product views, cart events, and checkout events</li>
                    <li>Referral and session data (e.g. links from social media)</li>
                  </ul>
                  <p className="privacy-paragraph">
                    This data is used to understand customer intent and platform performance.
                  </p>
                </div>

                <div className="privacy-subsection">
                  <h3 className="privacy-subsection-title">d) Technical Data</h3>
                  <ul className="privacy-list">
                    <li>IP address</li>
                    <li>Device and browser information</li>
                    <li>Log files and error data</li>
                  </ul>
                </div>
              </div>

              {/* Section 2 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">2. How We Use Information</h2>
                <p className="privacy-paragraph">We use collected information to:</p>
                <ul className="privacy-list">
                  <li>Provide and operate the Revexia platform</li>
                  <li>Analyze customer behavior and purchase intent</li>
                  <li>Improve product functionality and performance</li>
                  <li>Ensure platform security and reliability</li>
                  <li>Comply with legal and regulatory obligations</li>
                </ul>
                <p className="privacy-paragraph privacy-highlight">
                  Revexia does not send unsolicited messages and does not use data for spam or unauthorized outreach.
                </p>
              </div>

              {/* Section 3 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">3. Legal Basis for Processing (GDPR)</h2>
                <p className="privacy-paragraph">Under GDPR, Revexia processes personal data based on:</p>
                <ul className="privacy-list">
                  <li>User consent (for integrations and tracking)</li>
                  <li>Contractual necessity (to provide the service)</li>
                  <li>Legitimate interests (platform security, analytics, and improvement)</li>
                  <li>Legal obligations (where required)</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">4. Data Sharing</h2>
                <p className="privacy-paragraph privacy-highlight">We do not sell personal data.</p>
                <p className="privacy-paragraph">We may share data only with:</p>
                <ul className="privacy-list">
                  <li>Authorized service providers (e.g. cloud infrastructure, analytics)</li>
                  <li>Integration partners as required to deliver the service</li>
                  <li>Authorities where legally required</li>
                </ul>
                <p className="privacy-paragraph">
                  All service providers are contractually required to protect data.
                </p>
              </div>

              {/* Section 5 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">5. Data Storage & Security</h2>
                <ul className="privacy-list">
                  <li>Data is stored using secure cloud infrastructure</li>
                  <li>We apply technical and organizational security measures</li>
                  <li>Access is restricted to authorized personnel only</li>
                  <li>We retain data only as long as necessary for the purposes described</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">6. International Data Transfers</h2>
                <p className="privacy-paragraph">
                  Revexia operates globally. Data may be processed outside your country of residence.
                </p>
                <p className="privacy-paragraph">
                  Where required, we apply appropriate safeguards to ensure GDPR-compliant data transfers.
                </p>
              </div>

              {/* Section 7 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">7. Your Rights (GDPR)</h2>
                <p className="privacy-paragraph">
                  If you are located in the EU/EEA, you have the right to:
                </p>
                <ul className="privacy-list">
                  <li>Access your personal data</li>
                  <li>Request correction or deletion</li>
                  <li>Restrict or object to processing</li>
                  <li>Request data portability</li>
                  <li>Withdraw consent at any time</li>
                </ul>
              </div>

              {/* Section 8 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">8. Cookies & Tracking</h2>
                <p className="privacy-paragraph">
                  Revexia may use cookies or similar technologies to:
                </p>
                <ul className="privacy-list">
                  <li>Maintain sessions</li>
                  <li>Analyze usage</li>
                  <li>Improve platform performance</li>
                </ul>
                <p className="privacy-paragraph">
                  You can control cookies through your browser settings.
                </p>
              </div>

              {/* Section 9 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">9. Children's Data</h2>
                <p className="privacy-paragraph">
                  Revexia is not intended for children under the age of 16. We do not knowingly
                  collect data from children.
                </p>
              </div>

              {/* Section 10 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">10. Changes to This Policy</h2>
                <p className="privacy-paragraph">
                  We may update this Privacy Policy from time to time. Updates will be posted on
                  this page with a revised date.
                </p>
              </div>

              {/* Section 11 */}
              <div className="privacy-section">
                <h2 className="privacy-section-title">11. Contact Us</h2>
                <p className="privacy-paragraph">
                  If you have questions about this Privacy Policy or data protection practices, contact:
                </p>
                <div className="privacy-contact-box">
                  <p className="privacy-contact-brand">Revexia</p>
                  <a
                    href="https://www.revexia.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="privacy-contact-link"
                  >
                    🌍 https://www.revexia.ai
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer - Exact same as HomePage */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            {/* Footer Main Content */}
            <div className="footer-main-content">
              {/* Brand Section */}
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img src={Logo} alt="Revexia" className="footer-logo-image" />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated revenue with AI-driven personalization.
                </p>
              </div>

              {/* Informations Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  
                </ul>
              </div>

              {/* Social Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                      Instagram
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                      Twitter
                    </a>
                  </li>
                  <li>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              {/* Help Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                 
                  <li>
                    <a href="/terms">Terms & conditions</a>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                   <li>
                                      <Link to="/facebook-terms">Facebook Terms</Link>
                                    </li>
                </ul>
              </div>
            </div>

            {/* Footer Divider */}
            <hr className="footer-divider-line-v2" />

            {/* Footer Bottom - License */}
            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                © 2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <a href="/terms">Terms &amp; Conditions</a>
                <span className="separator-v2">|</span>
                <a href="/cookies">Cookies Policy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default PrivacyPolicy;